import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, LinkText } from 'components/common/styled/common-styled';
import { Error as FormError } from 'components/theme/Form/Form';
import { ICartExperience } from 'types/cart';
import { deriveResourcePicksPagePath } from 'utils/resourceSelections/resourceSelections';

export interface ResourceSoldOutErrorProps {
  cartItems: ICartExperience[];
  message: string;
}

const ResourceSoldOutError = ({
  cartItems,
  message,
}: ResourceSoldOutErrorProps) => {
  const { t: translate } = useTranslation();
  const resourcePicksPagePath = deriveResourcePicksPagePath(cartItems);

  return (
    <Flex direction="column" alignItem="flex-start" gap={8}>
      <FormError>{message}</FormError>
      {resourcePicksPagePath && (
        <LinkText
          to={resourcePicksPagePath}
          size={14}
          className="checkout-change-resource-selections"
        >
          {translate('changeResourceSelections')}
        </LinkText>
      )}
    </Flex>
  );
};

export default ResourceSoldOutError;
